module.exports = __webpack_public_path__ + "img/comercio-beneficio-2.53721630.svg";